module.exports = "https://cdn.littlereply.com/tt/resource/earn_guide_step_1@3x.22db96f9a160b3b218b2a629584cc87c.png";